import {User} from 'api/types/userTypes';
import {ManageUserActionType} from './types';

export const LOAD_USERS_REQUEST = 'ManageUserPage/LOAD_USERS_REQUEST';
export const LOAD_USERS_SUCCESS = 'ManageUserPage/LOAD_USERS_SUCCESS';
export const LOAD_USERS_FAILURE = 'ManageUserPage/LOAD_USERS_FAILURE';

export const ADD_USER_REQUEST = 'ManageUserPage/ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ManageUserPage/ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ManageUserPage/ADD_USER_FAILURE';

export const EDIT_USER_REQUEST = 'ManageUserPage/EDIT_USER_REQUEST';
export const EDIT_USER_SUCCESS = 'ManageUserPage/EDIT_USER_SUCCESS';
export const EDIT_USER_FAILURE = 'ManageUserPage/EDIT_USER_FAILURE';

export const DELETE_USER_REQUEST = 'ManageUserPage/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'ManageUserPage/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'ManageUserPage/DELETE_USER_FAILURE';

export const DOWNLOAD_RESULTS_REQUEST =
  'ManagerUserPage/DOWNLOAD_RESULTS_REQUEST';
export const DOWNLOAD_RESULTS_SUCCESS =
  'ManagerUserPage/DOWNLOAD_RESULTS_SUCCESS';
export const DOWNLOAD_RESULTS_FAILURE =
  'ManagerUserPage/DOWNLOAD_RESULTS_FAILURE';

export function loadUsersRequest(userType: string): ManageUserActionType {
  return {
    type: LOAD_USERS_REQUEST,
    payload: {
      userType,
    },
  };
}

export function loadUsersSuccess(data: User[]): ManageUserActionType {
  return {
    type: LOAD_USERS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function loadUsersFailure(error: Error): ManageUserActionType {
  return {
    type: LOAD_USERS_FAILURE,
    payload: {
      error,
    },
  };
}

export function addUserRequest(): ManageUserActionType {
  return {
    type: ADD_USER_REQUEST,
    payload: {},
  };
}

export function addUserSuccess(user: User): ManageUserActionType {
  return {
    type: ADD_USER_SUCCESS,
    payload: {
      selectedUser: user,
    },
  };
}

export function addUserFailure(error: Error): ManageUserActionType {
  return {
    type: ADD_USER_FAILURE,
    payload: {
      error,
    },
  };
}

export function editUserRequest(): ManageUserActionType {
  return {
    type: EDIT_USER_REQUEST,
    payload: {},
  };
}

export function editUserSuccess(user: User): ManageUserActionType {
  return {
    type: EDIT_USER_SUCCESS,
    payload: {
      selectedUser: user,
    },
  };
}

export function editUserFailure(error: Error): ManageUserActionType {
  return {
    type: EDIT_USER_FAILURE,
    payload: {
      error,
    },
  };
}

export function deleteUserRequest(): ManageUserActionType {
  return {
    type: DELETE_USER_REQUEST,
    payload: {},
  };
}

export function deleteUserSuccess(selectedUser: User): ManageUserActionType {
  return {
    type: DELETE_USER_SUCCESS,
    payload: {
      selectedUser,
    },
  };
}

export function deleteUserFailure(error: Error): ManageUserActionType {
  return {
    type: DELETE_USER_FAILURE,
    payload: {
      error,
    },
  };
}

export function downloadResultsRequest(): ManageUserActionType {
  return {
    type: DOWNLOAD_RESULTS_REQUEST,
    payload: {},
  };
}

export function downloadResultsSuccess(): ManageUserActionType {
  return {
    type: DOWNLOAD_RESULTS_SUCCESS,
    payload: {},
  };
}

export function downloadResultsFailure(error: Error): ManageUserActionType {
  return {
    type: DOWNLOAD_RESULTS_FAILURE,
    payload: {
      error,
    },
  };
}
